import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const MASK_START_BEFORE_OVERLAP = 0.8;

const initExpertise = (section) => {
  const items = gsap.utils.toArray('.expertise__item', section);

  if (items.length < 2) {
    return;
  }

  gsap.matchMedia().add('(min-width: 769px)', () => {
    items.forEach((item, index) => {
      item.style.zIndex = index + 1;

      if (index === items.length - 1) {
        return;
      }

      const mask = item.querySelector('.expertise__item-mask');

      if (!mask) {
        return;
      }

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: items[index + 1],
          start: () => {
            const stickyTop = parseFloat(getComputedStyle(item).top) || 0;

            return `top top+=${
              stickyTop + item.offsetHeight * (1 + MASK_START_BEFORE_OVERLAP)
            }`;
          },
          end: () => {
            const stickyTop = parseFloat(getComputedStyle(item).top) || 0;

            return `top top+=${stickyTop}`;
          },
          scrub: 0.7,
          invalidateOnRefresh: true,
        },
      });

      timeline
        .fromTo(mask, { opacity: 0 }, { opacity: 1, duration: 1, ease: 'none' })
        .to(item, { opacity: 0, duration: 0.2, ease: 'none' }, 0.8);
    });
  });
};

const initExpertiseSections = () => {
  document.querySelectorAll('.expertise').forEach((section) => {
    if (section.dataset.expertiseInitialized) {
      return;
    }

    section.dataset.expertiseInitialized = 'true';
    initExpertise(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initExpertiseSections);
} else {
  initExpertiseSections();
}
